import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Sends a GA4 page_view event every time the route changes.
 *
 * Must be rendered inside a `<BrowserRouter>` (needs `useLocation`).
 * If GA has not been initialised (user rejected consent) the underlying
 * `trackPageView` call is a silent no-op.
 */
export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}
